import '../../style/';
import '../../wing-blank/style/';
import '../../flex/style/';
import '../../toast/style/';
import './index.less';



/** WEBPACK FOOTER **
 ** ./components/image-picker/style/index.web.tsx
 **/